import isMobileSized from './isMobileSized';

const A11Y_CONFIG = {
	slideLabelMessage: '',
	containerRoleDescriptionMessage: 'carousel',
	slideRole: ''
};

const NAVIGATION = {
	nextEl: '.icon.icon-caret-right',
	prevEl: '.icon.icon-caret-left'
};

const DEFAULT_CONFIG = {
	slidesPerView: 1,
	spaceBetween: 32,
	pagination: {
		el: '.swiper-pagination',
		clickable: true
	},
	navigation: NAVIGATION,
	breakpoints: {
		768: {
			slidesPerView: 2
		},
		992: {
			slidesPerView: 3
		}
	},
	a11y: A11Y_CONFIG
};

function getStackedConfig() {
	const isMobile = isMobileSized();

	return {
		effect: isMobile ? 'slide' : 'coverflow',
		loop: true,
		speed: 500,
		spaceBetween: isMobile ? 32 : 0,
		slidesPerView: 1,
		coverflowEffect: {
			depth: 250,
			rotate: 0,
			slideShadows: false
		},
		navigation: NAVIGATION,
		breakpoints: {
			768: {
				slidesPerView: 'auto',
				centeredSlides: true,
				coverflowEffect: {
					stretch: 100
				}
			},
			992: {
				slidesPerView: 'auto',
				centeredSlides: true,
				coverflowEffect: {
					stretch: -10
				}
			}
		},
		a11y: A11Y_CONFIG
	};
}

const CAROUSEL_CONFIGS = {
	default: DEFAULT_CONFIG,
	stacked: getStackedConfig()
};

/**
 * Returns Swiper initialization options for a named carousel layout.
 * Unknown types fall back to the default multi-slide carousel.
 *
 * @param {'default' | 'stacked'} [carouselType='default'] - Preset carousel layout.
 * @returns {Object} Swiper-compatible configuration object.
 * @example
 * modCarousel.init('#reviews', modUtils.getCarouselConfig());
 * @example
 * modCarousel.init('#reviews', modUtils.getCarouselConfig('stacked'));
 */
export default function getCarouselConfig(carouselType = 'default') {
	const config = CAROUSEL_CONFIGS[carouselType] ?? DEFAULT_CONFIG;

	return config;
}
